__turbopack_context__.v({
  "blocksBackgroundColor": "MapBlock-module-scss-module__zwUl7q__blocksBackgroundColor",
  "blocksFontColor": "MapBlock-module-scss-module__zwUl7q__blocksFontColor",
  "dropDownContainer": "MapBlock-module-scss-module__zwUl7q__dropDownContainer",
  "editButton": "MapBlock-module-scss-module__zwUl7q__editButton",
  "editDropDownMap": "MapBlock-module-scss-module__zwUl7q__editDropDownMap",
  "locationItemTransitionWrapper": "MapBlock-module-scss-module__zwUl7q__locationItemTransitionWrapper",
  "map": "MapBlock-module-scss-module__zwUl7q__map",
  "mapBlockContainer": "MapBlock-module-scss-module__zwUl7q__mapBlockContainer",
  "mapInsert": "MapBlock-module-scss-module__zwUl7q__mapInsert",
  "organizationTitle": "MapBlock-module-scss-module__zwUl7q__organizationTitle",
  "reorderBlocks": "MapBlock-module-scss-module__zwUl7q__reorderBlocks",
  "secondaryNavBackgroundColor": "MapBlock-module-scss-module__zwUl7q__secondaryNavBackgroundColor",
  "themeBackgroundColor": "MapBlock-module-scss-module__zwUl7q__themeBackgroundColor",
  "themeFontColor": "MapBlock-module-scss-module__zwUl7q__themeFontColor",
  "themeFontFamily": "MapBlock-module-scss-module__zwUl7q__themeFontFamily",
  "transitionAppear": "MapBlock-module-scss-module__zwUl7q__transitionAppear",
  "transitionAppearActive": "MapBlock-module-scss-module__zwUl7q__transitionAppearActive",
  "transitionAppearDone": "MapBlock-module-scss-module__zwUl7q__transitionAppearDone",
  "transitionEnter": "MapBlock-module-scss-module__zwUl7q__transitionEnter",
  "transitionEnterActive": "MapBlock-module-scss-module__zwUl7q__transitionEnterActive",
  "transitionEnterDone": "MapBlock-module-scss-module__zwUl7q__transitionEnterDone",
  "transitionExit": "MapBlock-module-scss-module__zwUl7q__transitionExit",
  "transitionExitActive": "MapBlock-module-scss-module__zwUl7q__transitionExitActive",
  "transitionExitDone": "MapBlock-module-scss-module__zwUl7q__transitionExitDone",
});
